var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerMenuDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H23H2Z",
    fill: "#B9B9C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H23",
    stroke: "#B9B9C1",
    strokeWidth: 3.24,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10H23H2Z",
    fill: "#B9B9C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 10H23",
    stroke: "#B9B9C1",
    strokeWidth: 3.24,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 18H23H2Z",
    fill: "#B9B9C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 18H23",
    stroke: "#B9B9C1",
    strokeWidth: 3.24,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenuDark);
export default __webpack_public_path__ + "static/media/hamburger-menu-dark.0de692f1a0af51ea33995cadeb3c59ba.svg";
export { ForwardRef as ReactComponent };